import React from "react";
import { components, type MultiValueGenericProps, type OptionProps } from "react-select";
import { Checkbox, View, Text } from "@components";

import type { ValueOptionType } from "./";

type MultiOption = {
  ...ValueOptionType,
  data: {
    value: number,
    label: string,
    warning?: string,
  },
};

export const MultiSelectOption = (props: OptionProps<MultiOption>) => (
  <components.Option {...props}>
    <View direction="row" alignItems="center" justifyContent="space-between">
      <View direction="row" alignItems="center" gap={3}>
        <Checkbox type="checkbox" checked={props.isSelected} onChange={() => null} />
        <label className="mb-0">{props.label}</label>
      </View>
      {props.data.warning && <Text color="negative">{props.data.warning}</Text>}
    </View>
  </components.Option>
);

export const MultiSelectValue = ({
  selectProps,
  data,
}: MultiValueGenericProps<ValueOptionType>) => {
  const getVal = selectProps.getOptionValue;
  const selected = selectProps.value;

  if (!selected?.length || getVal(data) !== getVal(selected[0])) return null;

  return (
    <View direction="row" gap={2}>
      <span>{selected[0].label}</span>
      {selected.length > 1 && (
        <span className="text-color-coffee-d1 font-weight-bold">{`(+${selected.length - 1})`}</span>
      )}
    </View>
  );
};
